/**
 * @flow
 * @relayHash 5dd0c0e2473805900e6c69a87a266791
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteProposalInput = {|
  clientMutationId?: ?string,
  context: MutationContext,
  proposalId: string,
  deleteTension?: ?boolean,
|};
export type MutationContext = {|
  organizationId: string
|};
export type DeleteProposalMutationVariables = {|
  input: DeleteProposalInput
|};
export type DeleteProposalMutationResponse = {|
  +deleteProposal: ?{|
    +deletedProposalId: string,
    +tension: ?{|
      +id: string,
      +databaseId: string,
      +isAutogenerated: boolean,
      +processed: boolean,
      +proposal: ?{|
        +id: string
      |},
    |},
  |}
|};
export type DeleteProposalMutation = {|
  variables: DeleteProposalMutationVariables,
  response: DeleteProposalMutationResponse,
|};
*/


/*
mutation DeleteProposalMutation(
  $input: DeleteProposalInput!
) {
  deleteProposal(input: $input) {
    deletedProposalId
    tension {
      id
      databaseId
      isAutogenerated
      processed
      proposal {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteProposalPayload",
    "kind": "LinkedField",
    "name": "deleteProposal",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedProposalId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Tension",
        "kind": "LinkedField",
        "name": "tension",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "databaseId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAutogenerated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "processed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Proposal",
            "kind": "LinkedField",
            "name": "proposal",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteProposalMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteProposalMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "5dd0c0e2473805900e6c69a87a266791",
    "metadata": {},
    "name": "DeleteProposalMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '62ac582409012a4e60f443c9e2b97451';

module.exports = node;
